<template>
  <div>
    <!-- 弹框 -->
    <el-dialog title="" :visible="DialogShow" width="45%" @close="DialogShow=false">
      <span>
        <div class="from">
          <div class="formtitle">下载 Panel Book</div>
          <el-form :model="ruleForm" :rules="rules" ref="ruleForm">
            <el-form-item label="姓" prop="firstname">
              <el-input v-model="ruleForm.firstname" />
            </el-form-item>
            <el-form-item label="名" prop="lastname">
              <el-input v-model="ruleForm.lastname" />
            </el-form-item>
            <el-form-item label="电子邮箱" prop="mail">
              <el-input v-model="ruleForm.mail" />
            </el-form-item>
            <el-form-item label="公司名称" prop="company">
              <el-input v-model="ruleForm.company" />
            </el-form-item>
            <!-- <div>We need your permission to stay in touch.</div> -->
            <el-form-item prop="check" style="width:100%">

              <input class="check" type="checkbox" v-model="ruleForm.check"><span style="word-break: break-word;">是的，我想接收浩顿品牌的数字通信。我可以在任何时候使用任何电子邮件通信底部的退订链接选择退出通信。</span>
            </el-form-item>
          </el-form>

        </div>
      </span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="DialogShow = false">取消</el-button>
        <el-button type="primary" @click="submitForm('ruleForm','physician')" v-show="downloadid=='physician'">下载医生 Panel Book</el-button>
        <el-button type="primary" @click="submitForm('ruleForm','patient')" v-show="downloadid=='patient'">下载患者 Panel Book</el-button>
        <el-button type="primary" @click="submitForm('ruleForm','consumer')" v-show="downloadid=='consumer'">下载消费者 Panel Book</el-button>

      </span>
    </el-dialog>

    <!-- <a :href="url" :download="url" v-show="false" id="download"></a> -->
    <a href="/Holden APAC consumer panel book 2022.pdf" download="/Holden APAC consumer panel book 2022.pdf" v-show="false" id="consumer"></a>
    <a href="/Holden Panel book (Healthcare) 2022.pdf" download="/Holden Panel book (Healthcare) 2022.pdf" v-show="false" id="physician"></a>
    <a href="/Holden APAC Patient panel book 2022.pdf" download="/Holden APAC Patient panel book 2022.pdf" v-show="false" id="patient"></a>

    <!-- Download our Panel Book -->
    <div class="download">
      <div class="title">
        下载我们的 Panel Book
      </div>
      <div class="value">
        <div class="physician box">
          <div class="img" @click="btn('/physicians')">
            医生
            <img src="@/assets/img/Asia Panels/doctor.jpg" alt="">
          </div>
          <button @click="download('physician')">下载</button>
        </div>
        <div class="patient box">
          <div class="img" @click="btn('/patients')">
            患者
            <img src="https://holden-resource.oss-cn-shanghai.aliyuncs.com/holden/Asia Panels/Patient.png" alt="">
          </div>
          <button @click="download('patient')">下载</button>
        </div>
        <div class="consumer box">
          <div class="img" @click="btn('/consumer')">
            消费者
            <img src="https://holden-resource.oss-cn-shanghai.aliyuncs.com/holden/Asia Panels/Consumer.png" alt="">
          </div>
          <button @click="download('consumer')">下载</button>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
const defaultForm = {
  action:'Panel',
  actionCase:'DownLoad',
  targetName: "",
  mail: "",
  firstname: "",
  lastname: "",
  company: "",
  check: true
};
import { panelDownloads,actionRecords } from "@/api/api";

export default {
  data() {
    const check = (rule, value, callback) => {
      if (value == false) {
        return callback(new Error("请填写此必填项"));
      } else {
        callback();
      }
    };
    return {
      url: "",
      DialogShow: false,
      downloadid: "",
      ruleForm: JSON.parse(JSON.stringify(defaultForm)),
      rules: {
        firstname: [{ required: true, message: "请填写此必填项", trigger: "blur" }],
        lastname: [{ required: true, message: "请填写此必填项", trigger: "blur" }],
        company: [{ required: true, message: "请填写此必填项", trigger: "blur" }],
        mail: [
          { required: true, message: "请填写此必填项", trigger: "blur" },
          { type: "email", message: "电子邮件格式必须正确.", trigger: ["blur"] }
        ],
        // check: [{ required: true, message: "请填写此必填项", trigger: "blur" }, { validator: check }]
      }
    };
  },
  methods: {
    // 点击提交
    submitForm(formName, id) {
      let _this = this;
      // 数据写入表单
      _this.$refs[formName].validate(valid => {
        if (valid) {
          _this.ruleForm.fullName = _this.ruleForm.firstname + " " + _this.ruleForm.lastname;
          let ruleForm = {
            action:"Panel",
            actionCase:"DownLoad",
            firstName: _this.ruleForm.firstname,
            fullName: _this.ruleForm.fullName,
            mail: _this.ruleForm.mail,
            company: _this.ruleForm.company
          };
          //   console.log(this.ruleForm);
          localStorage.setItem("form", JSON.stringify(this.ruleForm));
          var form = JSON.parse(localStorage.getItem("form"));
          form.targetName = id;
          console.log(form);
          // 提交表单数据
          actionRecords(form).then(res => {
            // console.log(form);
            // 如果没有cookie
            // 提交成功
            if (res.code == 10000) {
              // 下载pannel
              // 将id赋值给downloadid
              this.downloadid = id;
              console.log(2);
              // 关闭弹框
              this.DialogShow = false;
                // 如果是同意或者没点，存入cookie
               if (localStorage.getItem("agreeCookies")) {
                var val = localStorage.getItem("agreeCookies");
                var dataobj = JSON.parse(val);
                if (dataobj.val == "agree") {
                  this.$cookies.set("HoldenCookies", "panelDownloads");
                }
              }else if(this.$cookies.isKey("defaultcookies")){
                  this.$cookies.set("HoldenCookies", "panelDownloads");

              }
              // 点击id为id的下载标签
              var a = document.getElementById(id);
              console.log(a);
              a.click();
            }
          });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },

    download(id) {
      // 如果有cookie
      if (this.$cookies.isKey("HoldenCookies")) {
        // console.log(3);
        this.DialogShow = false;
        // 直接下载
        var a = document.getElementById(id);
        // console.log(a);
        a.click();
        var form = JSON.parse(localStorage.getItem("form"));
        // console.log(form);
        form.targetName = id;
        actionRecords(form).then(res => {
          console.log(form);
        });
      } else {
        console.log(1);
        this.DialogShow = true;
        this.downloadid = id;
      }
    },
    btn(path) {
      // 跳转页面
      this.$router.push({
        path
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.download {
  padding: 50px 120px;
  background-color: #fff;
  .title {
    font-size: 40px;
    font-weight: 700;
  }
  .value {
    display: flex;
    justify-content: space-around;
    flex-wrap: wrap;
    .box {
      margin-top: 30px;
      width: 25%;
      .img {
        font-size: 25px;
        text-align: center;
        padding: 14px;
        border: 1px solid #d5dbe5;
        border-radius: 10px;
        box-shadow: 4px 4px 4px 0 #d5dbe5;
        img {
          margin-top: 14px;
          width: 100%;
          border-radius: 10px;
        }
      }
      button {
        width: 100%;
        height: 50px;
        font-size: 25px;
        margin-top: 20px;
        border: none;
        border-radius: 10px;
        background-color: #6cdf89;
        color: #fff;
        font-weight: 700;
      }
    }
  }
}
.check {
  margin-right: 10px;
}
.from {
  // width: 60%;
  // margin: 80px auto;
  // padding: 30px;
  // transform: scale(1.3);
  padding-top: 0px;
  .formtitle {
    text-align: center;
    font-weight: 700;
    font-size: 25px;
    color: #ff0000;
  }
  @media screen and (max-width: 570px) {
    .formtitle {
      font-size: 45px;
    }
  }
  .el-form {
    // display: flex;
    // flex-wrap: wrap;
    // justify-content: space-between;
    padding: 10px;
    /deep/ .el-form-item {
      display: inline-block;
      display: flex;
      // flex-wrap: wrap;
      justify-content: start;
      &:nth-child() {
        .el-form-item__label {
          // margin-left: 7px;
        }
      }
      &:not(.text) {
        // width: 50%;
      }
      &.text {
        width: 100%;
      }
      .el-form-item__content {
        font-size: 11px;
        line-height: 20px;
        flex: 1;
        .el-input {
          width: 238px !important;
        }
      }

      .el-form-item__label {
        width: 125px;
        font-size: 15px;
        display: block;
        font-weight: normal;
      }
      .el-textarea__inner {
        min-height: 104px !important;
      }
      .el-input__inner,
      .el-textarea__inner {
        background: #fafafa;
        border: 1px solid #e6e6e6;
        border-radius: 7px;
        font-size: 15px;
        width: 390px;
      }
      @media screen and (max-width: 576px) {
        .el-input__inner {
          font-size: 35px;
          width: 700px;
          height: 80px;
        }
        .el-form-item__label {
          font-size: 35px;
          width: 250px;
        }
        .el-form-item__content {
          font-size: 30px;
          line-height: 40px;
        }
      }
      .el-form-item__error {
        font-size: 12px !important;
      }
    }
  }
  & > * {
    margin: 20px;
  }
  div {
    margin-top: 12px;
  }
  .button {
    margin: 0 auto;
    margin-top: 20px;
    background: #217df6;
    font-size: 13px;
    color: #fff;
    border-radius: 7px;
    text-align: center;
    width: 150px;
    padding: 10px;
    // height: 34px;
    // line-height: 34px;
    cursor: pointer;
  }
  @media screen and (max-width: 576px) {
    .button {
      font-size: 35px;
    }
  }
}
@media screen and (max-width: 576px) {

  .download {
    .title {
      font-size: 80px;
    }
    .value {
      .box {
        width: 80%;
        margin-bottom: 100px;
        .img {
          font-size: 70px;
          padding: 60px;
        }
        button {
          font-size: 60px;
          height: 120px;
        }
      }
    }
  }
}
</style>
<style lang="scss" scoped>
@media screen and (max-width: 576px) {
  /deep/.el-dialog__wrapper {
    .el-dialog {
      width: 100% !important;
      .el-dialog__footer {
        .el-button {
          font-size: 70px;
          padding: 20px;
        }
      }
    }
  }
}
</style>